import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import GroupIcon from "@material-ui/icons/Group";
import { Link, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from "@material-ui/core";
import jwt_decode from 'jwt-decode';

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 600
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: `10px`,
    height: "100%",
    width: "99%",
    marginTop: theme.spacing(7)
  },
  link: {
    color: "rgba(0,0,0,0.65)",
    textDecoration: "none",
    marginLeft: "10%",
    alignSelf: "flex-start",
    "&:hover": {
      color: "rgba(0,0,0,1)"
    }
  }
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SimpleTable() {
  const classes = useStyles();

  let query = useQuery();

  const [data, upDateData] = React.useState([]);
  const [firstLoad, setLoad] = React.useState(true);
  const [message, setMessage] = React.useState("Select Member to add to ForeUp");

  let isLoading = true;

  function backLink() {
    return (
      <Link className={classes.link} to="/">
        {" "}
        <Typography align="left">
          &#x2190; Back to Search
        </Typography>{" "}
      </Link>
    )
  }

  async function sampleFunc(params) {
    let requestBody = {
      associationId: 53
    }
    let validRequest = false;
    if (params?.firstName && params.firstName.trim().length > 0) {
      requestBody.firstName = params.firstName;
      validRequest = true;
    }
    if (params?.lastName && params.lastName.trim().length > 0) {
      requestBody.lastName = params.lastName;
      validRequest = true;
    }
    if (params?.courseId && params.courseId.trim().length > 0) {
      requestBody.courseId = params.courseId;
    }
    if (params?.ghinNumber && params.ghinNumber.trim().length > 0) {
      const ghin = parseInt(params.ghinNumber);
      if (ghin > 0) {
        requestBody.ghin = ghin;
        validRequest = true;
      }
    }

    if (validRequest) {
      if (!!token && token.trim().length > 0 && token != "null") {
        // let response = await fetch("/searchGhinGolfer");
        try {
          const response = await fetch("/foreup/searchGolfer", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            // user: "ncga-int:5363L0p3Z6353",
            headers: {
              "Content-Type": "application/json",
              "X-Authorization": `Token ${token}`
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: JSON.stringify(requestBody) // body data type must match "Content-Type" header
          });
          let body = await response.json();
          for(let i=0; i< body.length; i++) {
            body[i].index = i;
          }
          isLoading = false;
          upDateData(body);
        } catch(e) {
          console.dir(e);
        }
      }
      else if (requestBody.courseId) {
        try {
          const response = await fetch("/searchForeupGolfer", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            // user: "ncga-int:5363L0p3Z6353",
            headers: {
              "Content-Type": "application/json"
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: JSON.stringify(requestBody) // body data type must match "Content-Type" header
          });
          let body = await response.json();
          console.log(`searchForeupGolfer result`);
          console.dir(body);
          for(let i=0; i< body.length; i++) {
            body[i].index = i;
          }
          console.log(`updating data...`);
          isLoading = false;
          upDateData(body);
          console.log(`setting isLoading to false...`);
          console.log(`set isLoading to false`);
        } catch(e) {
          console.error(`error in searchForeupGolfer`, e);
        }
      }
    }
  }

  const token = query.get("token");
  if (firstLoad) {
    setLoad(false);
    const g = query.get("ghinNumber");
    const fn = query.get("firstName");
    const ln = query.get("lastName");
    const ci = query.get("courseId");
    sampleFunc({
      ghinNumber: g,
      firstName: fn,
      lastName: ln,
      courseId: ci
    });
  }

  if (data.length > 0) isLoading = false;

  async function upsertForeupGolfer(toInput) {
    console.dir(toInput);
    // toInput = '{"ghin":1106250,"associationid":53,"ghinclubid":23924,"email":"kameron.fudenna@gmail.com","birthdate":"4/6/2007","address":{"line1":"5512 Treasure Dr","line2":"","city":"Rocklin","state":"CA","postal_code":"95765","country":"USA"},"prefix":"","firstname":"Kameron","middlename":"","lastname":"Fudenna","suffix":"","gender":"M","membertype":"J"}';
    isLoading = true;

    try {
      if (!!token && token.trim().length > 0 && token != "null") {
        setMessage(`Adding Member to ForeUp...`);
        const response = await fetch("/foreup/upsertGolfer", {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
            "Content-Type": "application/json",
            "X-Authorization": `Token ${token}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *client
          body: JSON.stringify(toInput) // body data type must match "Content-Type" header
        });
        let body = await response.json();
        console.dir(body);
        isLoading = false;
        return body;
      }
      else if (!!courseId) {
        setMessage(`Adding Member to ForeUp...`);
        const response = await fetch("/upsertForeupGolfer", {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *client
          body: JSON.stringify(toInput) // body data type must match "Content-Type" header
        });
        let body = await response.json();
        console.dir(body);
        isLoading = false;
        return body;
      }
    } catch(e) {
      isLoading = false;
      return {error: e};
    }
  }

  const handleAddMember = async (event) => {
    event.preventDefault();
    console.dir(event);
    console.log(event.target[0].value);
    const ghinNumber = event.target[0].value;
    const email = event.target[1].value;
    const firstName = event.target[2].value;
    const lastName = event.target[3].value;
    // {"ghin":1106250,"courseId":9039,"email":"kameron.fudenna@gmail.com","firstname":"Kameron","lastname":"Fudenna","forceCreateGolfer":false,"fetchMagicToken":true}
    const toInput = { ghin: ghinNumber, associationId: 53, courseId: parseInt(decoded?.course_id ?? courseId ?? "0"), email, firstName, lastName, fetchMagicToken: true, token };
    const result = await upsertForeupGolfer(toInput);
    
    console.dir(result);
    if (!result || result.error) {
      setMessage(`Unable to Add Member: ${result.error}`);
    }
    else if (result && result.magic_token_url) {
      // TODO: Redirect
      setMessage(`Member Added`);
      // if (!!token && token.trim().length > 0 && token != "null") {
      //   console.log(`redirect to ${result.magic_token_url}`);
      //   window.location.href = result.magic_token_url;
      // }
      // else {
      //   console.log(`no redirect since using courseId`);
      // }
    }
    else {
      setMessage(`Unable to Add Member`);
    }
  };


  let decoded;
  try {
    decoded = jwt_decode(token);
    console.dir(decoded);
    if (!!decoded) {
      if (!decoded.course_id) {
        decoded = undefined;
      }
    }
  } catch(e) {
    console.dir(e);
  }
  const courseId = query.get("courseId");
  let redirectToken = `/?token=${token}`;
  if (!!token && token.trim().length > 0 && token != "null") {
    redirectToken = `/?token=${token}`;
  }
  else if (!!courseId) {
    redirectToken = `/?courseId=${courseId}`;
  }
  // if (!decoded) {
  //   return (
  //     <div className={classes.paper}>
  //     <Avatar className={classes.avatar}>
  //       <GroupIcon />
  //     </Avatar>
  //     <Typography component="h1" variant="h5">
  //       GHIN Golfers
  //     </Typography>
  //     <Link className={classes.link} to="/">
  //       {" "}
  //       <Typography align="left">
  //         &#x2190; Back to Search
  //       </Typography>{" "}
  //     </Link>
  //   </div>
  //   );
  // }

  return (
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <GroupIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        GHIN Golfers
      </Typography>
      <Typography component="h3">
        {message}
      </Typography>
      <Link className={classes.link} to={redirectToken}>
        {" "}
        <Typography align="left">
          &#x2190; Back to Search
        </Typography>{" "}
      </Link>

      {isLoading ? (
        <CircularProgress />
      ) : (
        <TableContainer
          style={{ width: "80%", margin: "0 10px" }}
          component={Paper}
        >
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">GHIN Number</TableCell>
                <TableCell align="center">Name</TableCell>
                <TableCell align="center">Email</TableCell>
                <TableCell align="center">Gender</TableCell>
                <TableCell align="center">Club</TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row, index) => (
                <TableRow id={row.index} key={row.index}>
                  <TableCell align="center">{row.ghinNumber}</TableCell>
                  <TableCell align="center">{row.first_name} {row.last_name}</TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center">{row.gender}</TableCell>
                  <TableCell align="center">{row.club_name}</TableCell>
                  <TableCell align="center">
                    <form noValidate onSubmit={handleAddMember}>
                      <input type="hidden"
                        id="ghinNumber"
                        name="ghinNumber"
                        value={row.ghinNumber} />
                      <input type="hidden"
                        id="email"
                        name="email"
                        value={row.email ?? ''} />
                      <input type="hidden"
                        id="firstName"
                        name="firstName"
                        value={row.first_name} />
                      <input type="hidden"
                        id="lastName"
                        name="lastName"
                        value={row.last_name} />
                    <Button
                    type="submit"
                      // onClick={handleAddMember}
                    >Add Member</Button>
                    </form>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
       <Link className={classes.link} to={redirectToken}>
        {" "}
        <Typography align="left">
          &#x2190; Back to Search
        </Typography>{" "}
      </Link>
   </div>
  );
}